import Skeleton from "@/components/shared/Skeleton";
import { STAT_META } from "../common";
import { useNavigate } from "react-router-dom";

const StatCard = ({ label, value, metaIdx, loading, route, query, icon }) => {
  const m = STAT_META[metaIdx] ?? STAT_META[0];
  const Icon = icon ? icon : m.icon;
  const navigate = useNavigate();

  // A card with no route is a figure, not a link. It used to wear the pointer
  // and the hover lift anyway, so the two global user counts on the SuperAdmin
  // dashboard invited a click that went nowhere.
  const isLink = !loading && value != null && !!route;

  const handleNavigation = () => {
    if (!isLink) return;

    const queryString = query ? "?" + new URLSearchParams(query).toString() : "";

    navigate(`${route}${queryString}`);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleNavigation();
    }
  };

  return (
    <div
      className={`w-full rounded-xl transition ${isLink ? "cursor-pointer hover:shadow-md active:scale-[0.98]" : ""} ${loading || value == null ? "opacity-60" : ""}`}
      onClick={handleNavigation}
    >
      <div className="rounded-xl p-3 min-h-[82px] h-full flex flex-col justify-between bg-background-secondary border border-border-primary" style={{ borderLeftWidth: 4, borderLeftColor: m.color }}>
        <div className="flex items-center gap-2.5">
          {/* Icon accent colors are dynamic per-card, inline style is correct here */}
          <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 border" style={{ background: m.bg, borderColor: m.border }}>
            <Icon size={18} style={{ color: m.color }} />
          </div>

          {loading ? <Skeleton className="h-7 w-16" /> : <p className="text-[1.9rem] font-bold tracking-tight leading-none text-text-primary">{value ?? "—"}</p>}
        </div>

        {loading ? <Skeleton className="h-3.5 w-24 mt-1.5" /> : <p className="text-[0.78rem] mt-1.5 leading-tight text-text-secondary">{label}</p>}
      </div>
    </div>
  );
};

export default StatCard;
